import {setupFileUploader} from "../common/filesUploader";

/**
 * This is used on both customer view and public contractor view for site visits issues
 */
function initSiteVisitShow() {

	// Setup file uploader as a gallery for issues
	document.querySelectorAll('.issue.uppy-dashboard').forEach(uppyDashboardElement => {
		const files = JSON.parse(uppyDashboardElement.dataset.files);
		if (files && files.length) {
			setupFileUploader({
				target: `#${uppyDashboardElement.id}`,
				height: 240,
			}, null, files)
		}
	});

	// Setup files for the visit itself
	// noinspection JSUnresolvedVariable
	if (window.siteVisitFiles && window.siteVisitFiles.length) {
		setupFileUploader({
			target: `.site-visit-files.uppy-dashboard`,
			height: 240,
		}, null, window.siteVisitFiles)
	}
}

export {initSiteVisitShow}
